export const RoutePostImportEtlRun = "/import-etl/run";

export type ResponsePostImportEtlRun = {
  messages: string[];
  timedOut: boolean;
};
